import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class DeviceService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"device")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByUserBranch(idUser : String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"device/findByUserBranch/"+idUser)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findDevicesWithoutReporting(hours : number) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"device/findDevicesWithoutReporting/"+hours)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findDevicesWithoutReportingByUser(idUser:String, hours : number) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"device/findDevicesWithoutReporting/"+idUser+"/"+hours)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByUser(idUser : String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"device/findByUser/"+idUser)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(device:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"device",device)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(device:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"device/"+device.idDevice,device)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(id:String){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"device/"+id)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/device.service.ts